import fr from './fr-icon.svg';
import en from './en-icon.svg';
import lang from './language-selector-icon3.svg';
import orange from './orange.svg';
import google from './google-play.svg';
import apple from './app-store.svg';
import lightning from './lightning.svg';
import book from './book.svg';
import heart from './heart.svg';

export const homeIcons = {
    fr,
    en,
    orange,
    lang,
    google,
    apple,
    lightning,
    book,
    heart
};